import { useSelector } from 'react-redux';

import SelectWidget from '@plone/volto/components/manage/Widgets/SelectWidget';

export interface QuerySortingSelectionWidgetProps {}

const QuerySortingSelectionWidget: React.FC<
  QuerySortingSelectionWidgetProps
> = (props) => {
  const sortable_indexes = useSelector(
    (state: {
      querystring: { sortable_indexes: Record<string, { title: string }> };
    }) => state.querystring.sortable_indexes,
  );

  const choices = Object.keys(sortable_indexes).map((value: string) => [
    value,
    sortable_indexes[value].title,
  ]);

  return (
    <SelectWidget
      {...props}
      choices={choices}
      isMulti={false}
      noValueOption={false}
    />
  );
};

export default QuerySortingSelectionWidget;
